import { render, staticRenderFns } from "./live-form.vue?vue&type=template&id=42c3ba56&scoped=true&"
import script from "./live-form.vue?vue&type=script&lang=js&"
export * from "./live-form.vue?vue&type=script&lang=js&"
import style0 from "./live-form.vue?vue&type=style&index=0&id=42c3ba56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c3ba56",
  null
  
)

export default component.exports